/* eslint quote-props: ["error", "consistent"] */

const locale = {
  mstSideWeatherName: "Weather",
  mstSideDashboardName: "Thông tin khuyến nghị",
  mstSideUserName: "Manage user",
  mstSideInsightName: "Create Alert",
  mstSidePointName: "Location",
  mstSideHelpName: "Help",
  changePassword: "Change login information",
  logout: "Logout",
  changeAccount: "Change Account",
  mstpackageInfo: "Package Info",
  userInfo: "User Info",
  Welcome: "Welcome",
  Phone: "Phone",
  mstSideReport: "Report",
};

export default locale;
